module.exports = __webpack_public_path__ + "static/media/img18.bb6028f9.jpeg";